import { States } from '../../../../../../constants';

export const validStateOptions: string[] = [];
States.forEach((state) => validStateOptions.push(state.name));

export const projectTypeOptions = [
  'Affordable Homeownership',
  'Affordable Rental Housing: 4%, 9%',
  'Existing Operating Property',
  'Home Ownership',
  'Market Rate Multifamily',
  'Mixed Use',
  'Other',
];

export const constructionTypeOptions = [
  'Adaptive Reuse',
  'Historic Renovation',
  'In-Place Renovation',
  'Modular',
  'New Construction',
  'Renovation',
];

export const acquisitionTypes = [
  'From Municipality',
  'Off-Market',
  'On-Market',
  'Joint venture with land owner',
  'Other',
];

export const projectByRightOptions = ['Yes', 'No', 'Not Yet Determined'];

export const siteControlStatuses = [
  'None of the list',
  'LOI Obtained',
  'Purchase Contract Executed',
  'Property Purchased',
  'RFP Submitted',
  'Exclusive Negotiating Period Entered Into',
  'Other',
];

export const neighborhoods = [
  'Acipco-Finley',
  'Airport Highlands',
  'Apple Valley',
  'Arlington-West End',
  'Belview Heights',
  'Bridlewood',
  'Brown Springs',
  'Brownsville Heights',
  'Brummitt Heights',
  'Bush Hills',
  'Central City',
  'Central Park',
  'Central Pratt',
  'College Hills',
  'Collegeville',
  'Crestline',
  'Crestwood North',
  'Crestwood South',
  'Dolomite',
  'Druid Hills',
  'East Avondale',
  'East Birmingham',
  'East Brownville',
  'East Lake ',
  'East Thomas',
  'Eastwood',
  'Echo Highlands',
  'Enon Ridge',
  'Ensley',
  'Ensley Highlands',
  'Evergreen ',
  'Fairmont',
  'Fairview',
  'Five Points South',
  'Forest Park-South Avondale',
  'Fountain Heights',
  'Garden Highlands',
  'Gate City',
  'Germania Park',
  'Glen Iris',
  'Grasselli Heights',
  'Graymont',
  'Green Acres',
  'Harriman Park',
  'Highland Park',
  'Hillman',
  'Hillman Park',
  'Hooper City',
  'Huffman',
  'Industrial Center',
  'Inglenook',
  'Jones Valley',
  'Killough Springs',
  'Kingston',
  'Liberty Highlands',
  'Maple Grove',
  'Mason City',
  'North Avondale',
  'North Birmingham',
  'North East Lake',
  'North Pratt',
  'North Titusville',
  'Norwood',
  'Oak Ridge',
  'Oak Ridge Park',
  'Oakwood Place',
  'Overton',
  'Oxmoor',
  'Penfield Park',
  'Pine Knoll Vista',
  'Powderly',
  'Redmont Park',
  'Riley-Travellick',
  'Rising-West Princeton',
  'Roebuck',
  ' Roebuck Springs-South Roebuck',
  'Roosevelt',
  'Sandusky',
  'Sherman Heights',
  'Smithfield',
  'Smithfield Estates',
  'South East Lake',
  'South Pratt',
  'Southside',
  'South Titusville',
  'South Woodlawn',
  'Spring Lake',
  'Sun Valley',
  'Tarpley City',
  'Thomas',
  'Tuxedo',
  'Wahouma',
  'West Brownville',
  'West End Manor',
  'West Goldwire',
  'Woodland Park',
  'Woodlawn',
  'Wylam',
  'Zion City',
];